import { render, staticRenderFns } from "./VesselDocuments.vue?vue&type=template&id=b7987d60&scoped=true"
import script from "./VesselDocuments.vue?vue&type=script&lang=ts"
export * from "./VesselDocuments.vue?vue&type=script&lang=ts"
import style0 from "./VesselDocuments.vue?vue&type=style&index=0&id=b7987d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7987d60",
  null
  
)

export default component.exports